import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const PartialCheck = (props) => (
  <Icon viewBox="0 0 8 6" {...props}>
    <g>
      <defs/>
      <path d="M0 2h8v2H0z" className="cls-1" />
    </g>
  </Icon>
);
/*eslint-enable */

export default PartialCheck;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/PartialCheck.js